/** Copy and actions for signed-in users with no league workspaces. */

export const NO_LEAGUE_LANDING_TITLE = 'Choose how to get started';

export const NO_LEAGUE_LANDING_MESSAGE =
  'Join an existing league with an invite code, or start a new league as a commissioner when your subscription allows.';

export const NO_LEAGUE_LANDING_MEMBER_NOTE =
  'Joining someone else’s league? Ask your League Owner or Commissioner for an invite link or code.';

export const NO_LEAGUE_JOIN_CARD_TITLE = 'Join a league for free';
export const NO_LEAGUE_JOIN_CARD_DETAIL =
  'Enter an invite code or link from your commissioner to join immediately.';

export const NO_LEAGUE_COMMISSIONER_CARD_TITLE = 'Start a league as commissioner';
export const NO_LEAGUE_COMMISSIONER_CARD_DETAIL =
  'Creating a league requires an active commissioner subscription.';

export const NO_LEAGUE_ACTION_CREATE_LEAGUE = 'Start a league';
export const NO_LEAGUE_ACTION_VIEW_PRICING = 'View commissioner plans';
export const NO_LEAGUE_ACTION_ENTER_INVITE = 'Enter invite code';
export const NO_LEAGUE_ACTION_CONNECT_DISCORD = 'Connect Discord';

export const NO_LEAGUE_COMMISSIONER_SUBSCRIPTION_NOTE =
  'Commissioner subscription required to create a league.';
